'use client';

import { AtClickable, IAtClickableProps } from '@/components/atoms';
import {
  EClickableVariants,
  EClickableSize,
} from '@/components/atoms/at-clickable/at-clickable.types';
import { MlModal } from '@/components/molecules';
import {
  EModalVariants,
  IModalRefProps,
} from '@/components/molecules/ml-modal/ml-modal.types';
import { useRef } from 'react';
import { OrLeadGenForm } from '../or-lead-gen-form';
import { IOrLeadGenFormCmsProps } from '../or-lead-gen-form/or-lead-gen-form.types';
import { sendGTMClickEvent } from '@/components/helpers/analytics/gtm';

export const OrMiniCtaBlockAClient = ({
  leadGenForm,
  cta,
  interactionLocation,
}: {
  leadGenForm?: IOrLeadGenFormCmsProps;
  cta?: IAtClickableProps;
  interactionLocation: string;
}) => {
  const modalRef = useRef<IModalRefProps | null>(null);

  const handleOpen = () => {
    sendGTMClickEvent('Schedule Now', 'or-mini-cta-block-a', 'form-pop-up');

    modalRef?.current?.handleOpen();
  };

  return (
    <>
      {leadGenForm && (
        <AtClickable
          label={cta?.label || 'Schedule Now'}
          variant={cta?.variant || EClickableVariants.PRIMARY}
          size={cta?.size || EClickableSize.LG}
          outline={cta?.outline}
          onClick={handleOpen}
          type={cta?.type}
          interactLocation={cta?.label ? 'video-tour' : 'mini-cta-block-a'}
          shouldSendGTMEvent={false}
          className="mt-6 h-fit w-fit text-nowrap lg:ml-16 lg:mt-0 2xl:ml-20"
        />
      )}
      {!leadGenForm && cta?.label?.trim() && (
        <AtClickable
          {...cta}
          interactLocation={interactionLocation}
          className="mt-6 h-fit w-fit text-nowrap lg:ml-16 lg:mt-0 2xl:ml-20"
        />
      )}
      {leadGenForm && (
        <MlModal
          className="theme-light"
          variant={EModalVariants.LEAD_GEN}
          ref={modalRef}
        >
          <OrLeadGenForm
            formId={leadGenForm.form_id}
            formName={leadGenForm.title}
            heading={leadGenForm.heading}
            description={leadGenForm.description}
            headingElement={leadGenForm.heading_element?.select}
            headingVariant={leadGenForm.heading_variant?.select}
            formType={leadGenForm.form_type}
            isInModal={leadGenForm.is_in_modal}
            topSpacing={leadGenForm.top_spacing?.spacing_value}
            bottomSpacing={leadGenForm.bottom_spacing?.spacing_value}
          />
        </MlModal>
      )}
    </>
  );
};
